import useAppStore from "../../store/AppStore";
import i18n from "../../i18n/i18n";
import { useEffect, useState } from "react";
import { ColumnItem } from "../../common/models/table";
import { Drawer, Tag, Tooltip } from "antd";
import { ActionsKey } from "../../common/models/Actions";
import { useNavigate } from "react-router";
import { CustomButton } from "../../common/components/CustomButton/CustomButton";
import { Assets } from "../../assets";
import { useSaleOperationStore } from "./store/SaleOperationStore";
import { HttpStatusCode } from "axios";
import { CommercialOperation } from "./core/_request";
import { useTeamManagementListState } from "./store/TeamManagementStore";
import { Loader } from "../../common/components/Loader/Loader";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { separerMilliers } from "../../utilities/formatNUmber";
import { TbSettingsSearch } from "react-icons/tb";
import { API_URLs } from "../../utilities/API_URLs";
import { getOperationCategoryTag } from "../../utilities/operationCategoryTag";

const cols: ColumnItem[] = [
  {
    key: "reference",
    title: "Référence commande Equipe",
    dataIndex: "reference",
    searchType: "text",
    show: true,
  },
  {
    key: "travelReference",
    title: "Référence du voyage",
    dataIndex: "travelReference",
    searchType: "text",
    show: true,
  },
  {
    key: "ship",
    title: "Navire",
    dataIndex: "ship",
    searchKey: "ship",
    searchType: "text",
    show: true,
  },
  {
    key: "operationType",
    title: "Type Ops",
    dataIndex: "operationType",
    nestedKey: "operationType.id",
    show: true,
    render: (state: any) => {
      return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <span>{state?.name}</span>
        </div>
      );
    },
  },
  {
    key: "createdAt",
    title: "Date de création",
    dataIndex: "createdAt",
    show: true,
  },
  {
    key: "startAt",
    title: "Date de début",
    dataIndex: "startAt",
    show: true,
  },
  {
    key: "customer",
    title: "Client",
    dataIndex: "customer",
    show: true,
    nestedKey: "customer.id",
    render: (state: any) => {
      return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <span>{state?.name}</span>
        </div>
      );
    },
  },
  {
    key: "totalLoads",
    title: "Nombre total mouvement",
    dataIndex: "totalLoads",
    show: true,
    render: (state: any) => {
      return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <span>{state ? separerMilliers(state) : "-"}</span>
        </div>
      );
    },
  },
  {
    key: "operationState",
    title: "Status",
    dataIndex: "operationState",
    show: true,
    searchKey: "operationState",
    searchType: "select",
    selectUri: API_URLs.operations.selectStatus,
    render: (state: any) => {
      const {label, color} = getOperationCategoryTag(state?.id)
      return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <Tag color={color}>{label}</Tag>
        </div>
      );
    },
  },
  // {
  //   key: "reference",
  //   title: "TDM",
  //   dataIndex: "reference",
  //   show: true,
  // },
  // {
  //   key: "reference",
  //   title: "Nombre total mouvement",
  //   dataIndex: "reference",
  //   show: true,
  // },
];

export const SaleOperationsPage = () => {
  // const [columns, setColumns] = useState<any[]>(cols);
  const [openForm, setOpenForm] = useState<boolean>(false);

  const navigate = useNavigate();
  const { activeMenu } = useAppStore();

  const {
    saleOperationList,
    setSaleOperationList,
    setActioned,
    actioned,
    totalItems,
  } = useSaleOperationStore();
  const { pageState, setPageState, resetPageState } =
    useTeamManagementListState();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchAllSaleOperations(pageState);
  }, [pageState]);

  const onActionClick = (ops: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(ops?.id);
    } else if (action === "read") {
      navigate(`detail/${ops?.id}`);
    }
    // else {
    //   // loadRoleById(user, action);
    //   navigate(`operation/${ops?.id}`);
    // }
  };

  // const onNavigateOnDetails = (id: string) => {
  //   navigate(`detail/${id}`);
  // };

  const fetchAllSaleOperations = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await CommercialOperation.getAllOperations(params);
      if (res?.status === HttpStatusCode.Ok) {
        setSaleOperationList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await CommercialOperation.deleteOperation(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllSaleOperations();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <TitleHeader
        title={
          <span
            style={{
              fontSize: window.innerWidth >= 1200 ? "35px" : "20px",
              flexGrow: 1,
            }}
          >
            Gestion des opérations commerciales
          </span>
        }
        isSHowBack
        backUri="/app/operations"
      >
        <CustomButton
          className="d-flex align-items-center gap-2"
          style={{
            marginLeft: "15px",
            height: "30px",
            marginTop: "8px",
            //fontSize: window.innerWidth >= 1200 ? "18px" : "14px",
          }}
          onClick={() => navigate("add")}
        >
          <img src={Assets.iconsSvg.addBox} alt="" />
          Nouvelle opération
        </CustomButton>
      </TitleHeader>

      <div className="py-4">
        <LFTableV3
          columns={cols}
          data={saleOperationList}
          params={pageState}
          onAction={onActionClick}
          isCanShow={() => true}
          // isCanEdit={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          onChangePage={handleSetParams}
          otherActions={[
            ({ row }) => (
              <Tooltip title={"Paramétrer"}>
                <div
                  className=" cursor-pointer"
                  onClick={() => {
                    navigate(`operation/${row?.id}`);
                  }}
                >
                  <TbSettingsSearch
                    style={{
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </Tooltip>
            ),
          ]}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
        />

        <Drawer
          open={openForm || actioned !== null}
          placement="right"
          onClose={() => {
            setOpenForm(false);
            setActioned(null);
          }}
          width={"75%"}
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : i18n.t("NEW")
          }
        >
          <p></p>
        </Drawer>
      </div>
    </>
  );
};
